import styled from 'styled-components';
import { rem } from 'polished';
import TitleWidget from '../../core/TitleWidget';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledTitleWidget = styled(TitleWidget)`
  margin-bottom: ${rem('40px')};
  margin-left: ${rem('7px')};

  svg {
    top: ${rem('-6px')};
    left: ${rem('-7px')};
    width: ${rem('40px')};
  }

  ${mediaqueries.greaterThan('tablet')`
    line-height: ${rem('31px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    font-size: ${rem('20px')};
    padding-left: ${rem('56px')};

    & svg{
      width: ${rem('50px')};
      height: ${rem('50px')};
      top: ${rem('-15px')};
    }
  `};
`;

const StyledWrapperSearch = styled.div`
  text-align: right;
  ${mediaqueries.greaterThan('tabletLandscape')`
    margin-bottom: ${rem('35px')};
  `};
`;

const StyledBoxInside = styled.div`
  display: block;
  padding: 0 ${rem('20px')};
  max-width: ${rem('574px')};
  padding-bottom: ${rem('50px')};
  margin-top: ${rem('40px')};
  &:focus {
    outline: none;
  }

  ${mediaqueries.greaterThan('tablet')`
    margin: ${rem('42px')} 0 ${rem('27px')} ${rem('104px')}; 
    padding: 0;  
  `};

  ${mediaqueries.greaterThan('desktop')`
    margin: ${rem('50px')} auto ${rem('27px')};   
    max-width: ${rem('1232px')};
    padding-left: ${rem('30px')};
  `};
`;

const StyledWrapper = styled.div`
  margin-bottom: ${rem('30px')};
  max-width: ${rem('559px')};
`;

// export { StyledBoxInside, StyledWrapper, StyledTitleWidget };

//-------------------------------------------------------------------
// const StyledWrapper = styled.div`
// display: flex;
// `;

const StyledDate = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.colors.dark};
  padding: ${rem('5px')} ${rem('20px')};
  text-align: center;
`;

const StyledDay = styled.span`
  color: ${props => props.theme.colors.light};
  font-size: ${rem('15px')};
  font-family: ${props => props.theme.fonts.medium};
  text-transform: uppercase;
`;

const StyledNumber = styled(StyledDay)`
  font-size: ${rem('23px')};
`;

export {
  StyledBoxInside,
  StyledWrapper,
  StyledTitleWidget,
  StyledDate,
  StyledDay,
  StyledNumber,
  StyledWrapperSearch
};

//-------------------------------------------------------------------
